import { makeSelectors } from '@utils/css';

const floatingButtonSelectors = makeSelectors({
  speechSynthesis: "fab--speech-synthesis",
  notebook: "fab--notebook"
});

export { floatingButtonSelectors };
//# sourceMappingURL=selectors.js.map
